import { RootState } from '../../../app';

export const selectExtension = ({ extension }: RootState) => extension;

export const selectIsExtensionEventLoading = ({ extension }: RootState) =>
  extension.eventLoginLoading || extension.eventOpenLoading;
